import { render, staticRenderFns } from "./ActivitiesAdults.vue?vue&type=template&id=5626e0de&"
import script from "./ActivitiesAdults.vue?vue&type=script&lang=js&"
export * from "./ActivitiesAdults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports